import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import InfoTooltip from 'components/shared/InfoTooltip';
import Popover from 'components/shared/popover';
import { AttendanceStatus } from '../types';

const AttendancePopover = ({
  changeAttendanceStatus,
  hasAssignedContentAndFlag,
  hide,
  isMultiSession,
  removeAttendance,
  status,
}) => {
  const [assignContentOnUpdate, setAssignContentOnUpdate] = useState(
    hasAssignedContentAndFlag,
  );

  return (
    <Popover
      dismissCallback={hide}
      position="right"
      styleName={cn('AttendanceRSVP--Popover', {
        'minw-150': !hasAssignedContentAndFlag,
        'minw-250': hasAssignedContentAndFlag,
      })}
    >
      <div className="fw-b">Change Status</div>

      {(status === 'did_not_attend' || status === 'unconfirmed' || !status) && (
        <>
          <button
            type="button"
            onClick={() =>
              changeAttendanceStatus('did_attend', assignContentOnUpdate)
            }
            className="u-resetBtn AttendanceRSVP--PopoverButton"
          >
            {t('in_person_training.attendance.status.did_attend')}
          </button>
          {hasAssignedContentAndFlag && (
            <span className="ml-4">
              <input
                id="assignContentOnUpdate"
                type="checkbox"
                value={assignContentOnUpdate}
                defaultChecked={assignContentOnUpdate}
                onChange={() =>
                  setAssignContentOnUpdate(!assignContentOnUpdate)
                }
                className="mr-4"
              />
              <label htmlFor="assignContentOnUpdate" className="ml-4">
                {t('in_person_training.event_content.status_assign')}
              </label>
            </span>
          )}
        </>
      )}
      {(status === 'attended' ||
        status === 'did_attend' ||
        status === 'unconfirmed' ||
        !status) && (
        <>
          <button
            type="button"
            onClick={() => changeAttendanceStatus('did_not_attend')}
            className="u-resetBtn AttendanceRSVP--PopoverButton"
          >
            {t('in_person_training.attendance.status.did_not_attend')}
          </button>
          {hasAssignedContentAndFlag && (
            <span className="ml-4 fs-i">
              {t('in_person_training.event_content.status_not_unassign')}
              <InfoTooltip
                tooltip={t(
                  'in_person_training.event_content.status_unassign_tooltip',
                )}
                className="ml-4"
              />
            </span>
          )}
        </>
      )}
      {!isMultiSession && (
        <button
          type="button"
          onClick={() => removeAttendance()}
          className="u-resetBtn AttendanceRSVP--PopoverButton"
        >
          {t('in_person_training.event_overview.attendance.remove_guest')}
        </button>
      )}
    </Popover>
  );
};

AttendancePopover.propTypes = {
  changeAttendanceStatus: PropTypes.func.isRequired,
  removeAttendance: PropTypes.func.isRequired,
  status: AttendanceStatus.isRequired,
  hide: PropTypes.bool,
  hasAssignedContentAndFlag: PropTypes.bool,
};
export default AttendancePopover;
